import React, { useState, useCallback } from 'react';
import { View, Pressable } from 'react-native';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useForm, FormProvider } from 'react-hook-form';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { Fields, defaultValues } from 'app/src/elements/hookForms';
import { EMAIL_INVOICE } from './queries';
import MutationErrors from 'app/src/elements/MutationErrors';

export const FIELDS = {
  to: {
    label: 'To',
    type: 'email',
    rules: { required: true },
  },
  cc: {
    label: 'CC',
    type: 'email'
  },
};

const EmailInvoice = ({ txn, setShowModal, refetch, setEmailStatus }) => {
  const [formStatus, setFormStatus] = useState();
  const [mutationErrors, setMutationErrors] = useState();

  const resource = { to: txn.entityEmail, cc: 'jbrinkley@equiplincauctions.com' };

  const {
    register, control, handleSubmit, setValue, watch, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({
      fields: {...FIELDS},
      resource
    })
  });

  const [emailInvoice] = useMutation(EMAIL_INVOICE, {
    onCompleted: data => {
      if (data.emailInvoice.errors?.length) {
        setFormStatus(null);
        setMutationErrors(data.emailInvoice.errors);
      } else {
        if (refetch) { refetch(); }
        setShowModal(false);
        setEmailStatus('Invoice Emailed.')
      }
    }
  });

  const onSubmit = useCallback(input => {
    // setFormStatus('submitting');
    setShowModal(false);
    setEmailStatus('Emailing Invoice...');
    input['txnId'] = txn.id;
    emailInvoice({
      variables: input
    });
  });

  return (
    <View style={{ minWidth: '70vw' }}>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
        setValue={setValue}
      />

      <MutationErrors errors={mutationErrors} />

      <ButtonGroup>
        <Button label="Email Invoice" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EmailInvoice;
